var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.b618f00c2e959490adf1639a01bc95ae.svg#v';
                    var viewUrl = 'sprites.b618f00c2e959490adf1639a01bc95ae.svg#view-v';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };